<template>
  <modal
    name="user-active-permit"
    :classes="'customModal'"
    :scrollable="true"
    :reset="true"
    :adaptive="false"
    :width="1253"
    height="auto"
    @before-open="beforeOpen"
    @closed="closeModal()"
  >
    <div>
      <div
        class="modal-dialog modal-dialog-centered"
        role="document"
        v-if="!customerDetails"
      >
        <div class="modal-content">
          <div class="modal-header position-relative">
            <form action="#">
              <div class="form-group">
                  <!-- <label class="txt--xs txt--off-white mb-2 mr-2">Search Mode</label> -->
                  <ul class="top__filter__ul top__filter__ul--btn">
                      <li :class="{ active: quick_search_mode === 'users__by__license', 'mr-3': true }"
                          @click="setQuickSearchMode('users__by__license')">Users</li>
                      <li :class="{ active: quick_search_mode === 'permits__active', 'mr-3': true }"
                          @click="setQuickSearchMode('permits__active')">Permits</li>
                      <li :class="{ active: quick_search_mode === 'sessions__ongoing' }"
                          @click="setQuickSearchMode('sessions__ongoing')">Sessions</li>
                  </ul>
              </div>
              <input
                type="text"
                ref="searchField"
                :placeholder="quick_search_mode === 'permits__active' ? 'Search by name, email, phone, or custom identifier' : quick_search_mode === 'users__by__license' ? 'Search by name, email, phone, or plate' : 'Search by name, email, phone, or plate'"
                class="input__field"
                v-model="property_search"
                autofocus
              />
              <button type="reset" @click="clearSearch()">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-x-lg"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M13.854 2.146a.5.5 0 0 1 0 .708l-11 11a.5.5 0 0 1-.708-.708l11-11a.5.5 0 0 1 .708 0Z"
                  />
                  <path
                    fill-rule="evenodd"
                    d="M2.146 2.146a.5.5 0 0 0 0 .708l11 11a.5.5 0 0 0 .708-.708l-11-11a.5.5 0 0 0-.708 0Z"
                  />
                </svg>
              </button>
            </form>
            <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button> -->
          </div>
          <div class="modal-body">
            <div class="filter__items" style="width: 613px; height: 452px">
              <div>
                <div class="mt-2">
                  <div class="top__filter">
                    <ul class="top__filter__ul">
                        <!-- <li class="cursor-default" v-if="quick_search_mode === 'sessions__ongoing'">Ongoing Sessions</li>
                        <li class="cursor-default" v-if="quick_search_mode === 'permits__active'">Active Permits</li> -->
                    </ul>
                    <ul class="top__filter__ul" v-if="property_search != ''">
                      <li id="clear_filter_property" @click="clearSearch">
                        Clear
                      </li>
                      <!-- <li>None</li> -->
                    </ul>
                  </div>
                  <div class="propertyFilters" v-if="property_list.length > 0">
                    <p
                      class="txt--ss my-3 cursor-pointer text-white d-flex justify-content-between"
                      style="
                        border-bottom: 1px solid var(--secondaryDark);
                        padding-bottom: 8px;
                        padding-right: 10px;
                      "
                      v-for="(p, index) in property_list"
                      :key="index"
                    >
                      <span
                        class="cursor-pointer property_item"
                        style="font-size: 20px; flex-basis: 37%"
                        @click="showCustomerDetails(p)"
                        v-if="
                          p.subscription_status == 1 &&
                          p.booking_no == undefined
                        "
                      >
                        {{ p.first_name }} {{ p.last_name }}
                      </span>
                      <span
                        class="cursor-pointer property_item"
                        style="font-size: 20px; flex-basis: 37%"
                        v-if="
                          p.booking_no != undefined && p.booking_status == 1
                        "
                        @click="
                          getSessionDetails(
                            p.space_id,
                            p.booking_id,
                            p.booking_type
                          )
                        "
                      >
                        {{ p.first_name }} {{ p.last_name }}
                      </span>
                      <span
                        class="cursor-pointer property_item"
                        style="font-size: 20px; flex-basis: 37%"
                        v-if="
                          p.user_status == 1
                        "
                        @click="
                          getOneUser(p)
                        "
                      >
                        {{ p.first_name }} {{ p.last_name }}
                      </span>
                      <span
                        class="cursor-pointer property_item"
                        style="font-size: 14px; margin-right: -46px"
                        v-if="p.user_status == 1"
                        @click="
                          getOneUser(p)
                        "
                      >
                        {{ p.email }}
                      </span>
                      <span
                        class="cursor-pointer property_item font-weight-bold"
                        style="font-size: 14px; color: #8c8c8c; flex-basis: 25%"
                        v-if="p.subscription_status == 1"
                      >
                        {{ p.permit_name }}
                      </span>
                      <span
                        class="cursor-pointer property_item"
                        style="font-size: 14px; margin-right: -46px"
                        v-if="p.booking_status == 1"
                        @click="
                          getSessionDetails(
                            p.space_id,
                            p.booking_id,
                            p.booking_type
                          )
                        "
                      >
                        {{ p.booking_no }}
                      </span>
                      <span
                        class="cursor-pointer property_item"
                        style="color: var(--primaryColor)"
                      >
                        {{ p.status }}
                      </span>
                    </p>
                    <!-- <div slot="spinner" v-if="property_loader">
                      <div class="d-flex justify-content-center mt-4">
                        <div class="lds-ring">
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                        </div>
                      </div>
                    </div> -->
                    <infinite-loading
                      @infinite="getPaginateUsers"
                      :identifier="search_infiniteId"
                      v-if="property_list.length > 0 && load_more"
                    >
                      <div slot="spinner">
                        <div class="d-flex justify-content-center mt-4">
                          <div class="lds-ring">
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                          </div>
                        </div>
                      </div>
                      <div slot="no-more"></div>
                      <div slot="no-results">No data found</div>
                    </infinite-loading>
                  </div>

                  <div
                    class="propertyFilters d-flex justify-content-center"
                    v-else
                  >
                    <div slot="spinner" v-if="property_loader">
                      <div class="d-flex justify-content-center mt-4">
                        <div class="lds-ring">
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                        </div>
                      </div>
                    </div>
                    <p v-else class="txt--primary txt--ss my-3 txt--semi-bold">
                      No data found
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- User details -->
    <div
      class="row"
      v-if="customerDetails"
      style="
        background-color: var(--primaryDark);
        padding: 50px 30px;
        border-radius: 15px;
      "
    >
      <div class="col-md-6">
        <div class="content__box mb-4">
          <div class="content__box__body">
            <div class="top__filter align-items-center mb-1">
              <ul class="top__filter__ul">
                <li
                  class="cursor-pointer txt--semi-bold"
                  @click="customerDetails = false"
                >
                  <span class="mr-2"><i class="fas fa-chevron-left"></i></span>Search
                </li>
              </ul>
            </div>
            <h2 class="txt--fslg pb-1">
              {{ userDetails.first_name }} {{ userDetails.last_name }}
            </h2>

            <div class="d-flex align-items-center flex-wrap">
              <div class="d-flex align-items-center mr-4 mt-2">
                <p class="txt--fsxs opacity--50 text-truncate mr-3">Email</p>
                <p class="txt--fsxs text-truncate">
                  {{ userDetails.email }}
                </p>
              </div>
              <div class="d-flex align-items-center mr-4 mt-2">
                <p class="txt--fsxs opacity--50 text-truncate mr-3">Phone</p>
                <p class="txt--fsxs text-truncate">
                  {{ userDetails.phone || 'N/A' }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <!-- Permit Details -->
        <div class="content__box mb-4">
          <div class="content__box__body">
            <div class="top__filter">
              <ul class="top__filter__ul">
                <li class="cursor-default txt--semi-bold">Permit Details</li>
              </ul>
              <ul class="top__filter__ul">
              </ul>
            </div>

            <div class="d-flex align-items-center flex-wrap">
              <div class="d-flex align-items-center mr-4 mt-2">
                <p class="txt--fsxs opacity--50 text-truncate mr-3">
                  Subscription Id
                </p>
                <p class="txt--fsxs text-truncate cursor-pointer">
                  {{ userDetails.subscription_id }}
                </p>
                <input
                  type="hidden"
                  name="subscription_id"
                  id="subscription_id"
                />
              </div>
              <div class="d-flex align-items-center mr-4 mt-2">
                <p class="txt--fsxs opacity--50 text-truncate mr-3">
                  Permit Id
                </p>
                <p class="txt--fsxs text-truncate cursor-pointer">
                  {{ userDetails.permit_id }}
                </p>
                <input type="hidden" name="permit_id" id="permit_id" />
              </div>
              <div class="d-flex align-items-center mr-4 mt-2">
                <p class="txt--fsxs opacity--50 text-truncate mr-3">
                  Allowed Vehicles
                </p>
                <p class="txt--fsxs text-truncate">
                  {{
                    userDetails.vehicle_count != ""
                      ? userDetails.vehicle_count
                      : "All"
                  }}
                </p>
              </div>
              <div class="d-flex align-items-center mr-4 mt-2">
                <p class="txt--fsxs opacity--50 text-truncate mr-3">
                  Permit Name
                </p>
                <p class="txt--fsxs text-truncate">
                  {{ userDetails.permit_name }}
                </p>
              </div>
              <div class="d-flex align-items-center mr-4 mt-2">
                <p class="txt--fsxs opacity--50 text-truncate mr-3">Status</p>
                <p class="txt--fsxs text-truncate">
                  {{ userDetails.status }}
                </p>
              </div>
              <div class="d-flex align-items-center mr-4 mt-2">
                <p class="txt--fsxs opacity--50 text-truncate mr-3">
                  Permit Type
                </p>
                <p class="txt--fsxs text-truncate">
                  {{ userDetails.recurring == 1 ? "Recurring" : (userDetails.flex_permit != 1 ? "One Time" : "Flex") }}
                </p>
              </div>
            </div>
            
            <div class="d-flex align-items-center flex-wrap mt-2" v-if="userDetails.price_breakdown.subtotal">
              <div class="modal__payment__text mr-4 mt-2">
                <div class="sessions_start_duration text-right mr-3">
                  <p class="txt--fsxs opacity--50 text-truncate">Subtotal</p>
                </div>
                <div class="activity__msg txt--semi-bold">
                  <p class="txt--fsxs text-truncate">
                    ${{ userDetails.price_breakdown.subtotal.toFixed(2) }}
                  </p>
                </div>
              </div>
              <div class="modal__payment__text mr-4 mt-2">
                <div class="sessions_start_duration text-right mr-3">
                  <!-- <p class="txt--fsxs opacity--50 text-truncate">Application Fee</p> -->
                  <p class="txt--fsxs opacity--50 text-truncate">Parking Tax</p>
                </div>
                <div class="activity__msg txt--semi-bold">
                  <!-- <p class="txt--fsxs text-truncate">${{approved_permit_details.price_breakdown.application_fee.toFixed(2)}}</p> -->
                  <p class="txt--fsxs text-truncate">
                    ${{ userDetails.price_breakdown.parking_tax.toFixed(2) }}
                    {{
                      userDetails.price_breakdown.tax_included == 1
                        ? "(Include)"
                        : ""
                    }}
                  </p>
                </div>
              </div>
              <div class="modal__payment__text mr-4 mt-2">
                <div class="sessions_start_duration text-right mr-3">
                  <p class="txt--fsxs opacity--50 text-truncate">Total Price</p>
                </div>
                <div class="activity__msg txt--semi-bold">
                  <p class="txt--fsxs text-truncate">
                    ${{ userDetails.price_breakdown.total_price.toFixed(2) }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Custom Identifiers -->
        <div class="content__box mb-4"
          v-if="userDetails && userDetails['custom_identifiers'] && userDetails['custom_identifiers'].length > 0">
          <div class="content__box__header pb-2">
            <div class="top__filter">
              <ul class="top__filter__ul">
                <li class="cursor-default txt--semi-bold">
                  Custom Identifiers
                </li>
              </ul>
            </div>  
            <div class="row pt-2">
              <div class="col">
                <p class="txt--xs txt--semi-bold opacity--50">Name</p>
              </div>
              <div class="col">
                <p class="txt--xs txt--semi-bold opacity--50">Value</p>
              </div>
              <!-- <div class="col">
                <p class="txt--xs txt--semi-bold opacity--50">Action</p>
              </div> -->
            </div>
          </div>
          <div class="content__divider"></div>
          <div class="content__box__body pt-0">
            <div class="row pt-2" v-for="(identifier, index) in userDetails['custom_identifiers']"
              :key="index">
              <div class="col">
                <p class="txt--ss">{{ identifier.key }}</p>
              </div>
              <div class="col">
                <p class="txt--ss">{{ identifier.value }}</p>
              </div>
              <!-- <div class="col">
                <a href="javascript:void(0);" class="text-danger"
                  @click="removeCustomIdentifiers(identifier, 'approved')"><i class="fas fa-trash"></i></a>
              </div> -->
            </div>
          </div>
        </div>
        <!-- Cards list -->          
        <div class="content__box mb-4">
          <div style="max-height: 170px; overflow: auto;">
            <div class="content__box__body">
              <div class="top__filter align-items-center mb-1">
                <ul class="top__filter__ul">
                  <li class="cursor-default txt--semi-bold">
                    Cards
                  </li>
                </ul>
                <ul class="top__filter__ul">
                  <li class="cursor-default opacity--1">
                  <!-- <span
                      class="font-weight-normal txt--green"
                      >Valid</span
                  >
                  <span
                      class="font-weight-normal txt--red"
                  
                      >Invalid</span
                  > -->
                  </li>
                </ul>
              </div>
              <div class="d-flex flex-wrap mb-3" v-for="(card, index) in userDetails.card_list" :key="index">
                <div class="payment__card" v-if="card && card.brand != ' '">
                  <img :src="getCreditcardLogo(card.brand)" alt="CardImage" />
                </div>
                <div class="payment__card" v-else>
                  <img
                  src="@/assets/images/DebitCardImage/credit-card.png"
                  alt="cardImage"
                  />
                </div>
                <div class="modal__payment__text pl-3">
                  <div class="sessions_start_duration text-right mr-3">
                  <p class="txt--fsxs opacity--50 text-truncate">Type</p>
                  <p class="txt--fsxs opacity--50 pt-2 text-truncate">
                      Last 4
                  </p>
                  </div>
                  <div class="activity__msg txt--semi-bold">
                  <p class="txt--fsxs text-truncate">
                      {{ card.brand.toUpperCase()  }}
                  </p>
                  <p class="txt--fsxs pt-2 text-truncate">
                      {{ card.last4_digit }}
                  </p>
                  </div>
                </div>
                <div class="modal__payment__text pl-5">
                  <div class="sessions_start_duration text-right mr-3">
                  <p class="txt--fsxs opacity--50 text-truncate">Exp</p>
                  </div>
                  <div class="activity__msg txt--semi-bold">
                  <p class="txt--fsxs text-truncate">
                      {{ card.exp_month + "/" + card.exp_year }}
                  </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Vehicle details -->
        <div class="content__box">
          <div style="max-height: 170px; overflow: auto;">
            <div class="content__box__body">
              <div class="top__filter align-items-center mb-1">
                <ul class="top__filter__ul">
                  <li class="cursor-default txt--semi-bold">Vehicles</li>
                </ul>
                <ul class="top__filter__ul">
                  <!-- <li >Update Vehicle Allowance</li> -->
                </ul>
              </div>
              <div class="d-flex flex-wrap mb-3" v-for="(vehicle, index) in userDetails.vehicle_list" :key="index">
                <div class="activity__indicator">
                  <div>
                    <div :class="[vehicle.license_id !== '' ? 'sessions_number_box text-center' : 'text-center sessions_number_box_vin']">
                      <div class="txt--xs txt--red txt--bold images_state">
                        {{ vehicle.state_full_name || (vehicle.license_id !== "" ? vehicle.country : "") || vehicle.state }}
                      </div>
                      <p class="txt--fsxs text-truncate txt--bold pt-1"  v-if="vehicle.license_id != ''">
                        {{ vehicle.license_id.toUpperCase() }}
                      </p>
                      <p v-else class="txt--fsxs txt--bold pt-1">
                        {{ vehicle.vin_id | last_eight(8, "##") }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="modal__payment__text pl-3">
                  <div class="sessions_start_duration text-right mr-3">
                    <p class="txt--fsxs opacity--50 text-truncate">Year</p>
                    <p class="txt--fsxs opacity--50 pt-2 text-truncate">Make</p>
                  </div>
                  <div class="activity__msg txt--semi-bold">
                    <p class="txt--fsxs text-truncate">
                      {{ vehicle.vin_details && vehicle.vin_details.ModelYear || 'N/A' }}
                    </p>
                    <p class="txt--fsxs pt-2 text-truncate">
                      <!-- {{ userDetails.vehicle.make }} -->
                      {{
                        vehicle.vin_details && 
                        vehicle.vin_details.Make !== "" &&
                        vehicle.vin_details.Make !== undefined
                          ? vehicle.vin_details.Make
                          : "N/A"
                      }}
                    </p>
                  </div>
                </div>
                <div class="modal__payment__text pl-5">
                  <div class="sessions_start_duration text-right mr-3">
                    <p class="txt--fsxs opacity--50 text-truncate">Model</p>
                    <p class="txt--fsxs opacity--50 pt-2 text-truncate">
                      Color
                    </p>
                  </div>
                  <div class="activity__msg txt--semi-bold">
                    <p class="txt--fsxs text-truncate">
                      {{
                        vehicle.vin_details && 
                        vehicle.vin_details.Model !== "" &&
                        vehicle.vin_details.Model !== undefined
                          ? vehicle.vin_details.Model
                          : "N/A"
                      }}
                    </p>
                    <p class="txt--fsxs pt-2 text-truncate">
                      {{ vehicle.vin_details && vehicle.vin_details.Color || 'N/A' }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Permit Customer Session Details -->
      <!--<div class="col-md-7 mt-4 mt-md-0">
        <div class="content__box content__box--activity" style="height: 100%">s
          <div class="content__box__header pb-0">
              <div class="top__filter flex-nowrap align-items-center">
                <ul class="top__filter__ul">
                  <li>Sessions</li>
                </ul>
                <ul class="top__filter__ul search_form_control">
                  <li>
                    <input
                      type="text"
                      placeholder="Search license plate OR VIN"
                      aria-label="Search"
                      class="form-control form-control-sm"
                    />
                  </li>
                </ul>
                <ul class="top__filter__ul">
                  <li >Active</li>
                  <li>Past</li>
                </ul>
              </div>
            </div>
            <div class="content__divider"></div>
            <div
              id="session_div"
              class="
                content__box__body
                box__height box__height--session-property
              "
            >
              <div class="activity__list session__list" v-if="session_list.length> 0">
                <div v-for="(session, index) in session_list" :key="index">
                  <div :id="'session_'+index" class="activity__list session__list">
                    <div class="activity__new activity__new--property pb-0">
                      <div class="activity__indicator mb-2">

                        <div
                          :class="[
                            session.vehicle_details.license_id != ''
                              ? 'sessions_number_box text-center'
                              : 'text-center sessions_number_box_vin',
                          ]"
                        >
                          <div class="txt--xs txt--red txt--bold images_state">
                            {{
                              session.vehicle_details.state_full_name !=
                              ""
                                ? session.vehicle_details
                                    .state_full_name
                                : session.vehicle_details.license_id !=
                                  ""
                                ? session.vehicle_details.country
                                : ""
                            }}
                          </div>
                          <p class="txt--fsxs text-truncate txt--bold pt-1"  v-if="session.vehicle_details.license_id != ''">
                            {{
                              session.vehicle_details.license_id.toUpperCase()
                            }}
                          </p>
                          <p v-else class="txt--fsxs txt--bold pt-1">
                            {{
                              session.vehicle_details.vin_id
                                | last_eight(8, "##")
                            }}
                          </p>
                        </div>
                      </div>

                      <div class="activity__txt activity__txt--property mb-2">
                        <div class="sessions_start_duration text-right mr-3">
                          <p class="txt--fsxs opacity--50 text-truncate">
                            Start
                          </p>
                          <p class="txt--fsxs opacity--50 pt-2 text-truncate">
                            Duration
                          </p>
                        </div>
                        <div class="activity__msg txt--semi-bold">
                          <p class="txt--fsxs text-truncate">
                            {{ session.booking_start_date_formatted }}
                          </p>
                          <p class="txt--fsxs pt-2 text-truncate">
                            {{ session.stay_duration }}
                            <span
                              v-if="
                                session_type == 2 &&
                                session.booking_type != 'anonymous' &&
                                session.customer_type != 2
                              "
                              class="pl-2"
                            >
                              {{
                                "$" +
                                session.price_breakdown.payable_amount
                              }}
                            </span>
                          </p>
                        </div>
                      </div>
                      <div
                        class="
                          activity__address activity__address--property
                          mb-2
                        "
                      >
                        <p class="txt--xs opacity--50 text-truncate">
                          {{
                            session.property_name != ""
                              ? session.property_name
                              : session.display_address
                          }}
                        </p>
                        <p class="txt--xs opacity--50 text-truncate pt-2">
                          {{ session.customer_type_name }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <infinite-loading
                  @infinite="paginateSession"
                  :distance="10"
                  v-if="
                    session_list.length > 0 &&
                    session_load_more
                  "
                >
                  <div slot="spinner">
                    <div class="d-flex justify-content-center mt-4">
                      <div class="lds-ring">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </div>
                  </div>
                  <div slot="no-more"></div>
                  <div slot="no-results">No data found</div>
                </infinite-loading>
              </div>
              <div v-if="session_list.length == 0 && session_loader"
                class="
                  d-flex
                  justify-content-center
                  reports__details--body
                  m-customer--min-height
                "
              >
                <div class="lds-ring">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            </div>
        </div>
      </div>-->
    </div>
    <SessionDetails />
    <UserDetails />
  </modal>
</template>
<script>
import SessionDetails from "@/components/modals/sessionDetails";
import UserDetails from "@/components/modals/UserDetails";

export default {
  name: "UserActivePermit",
  components: {
    SessionDetails: SessionDetails,
    UserDetails,
  },
  data() {
    return {
      property_search: "",
      page: 1,
      load_more: false,
      property_list: [],
      pagination: [],
      search_infiniteId: +new Date(),
      customerDetails: false,
      userDetails: {},
      property_access: [],
      admin_access: false,
      user_list_source: null,
      property_loader: false,
      quick_search_mode: 'sessions__ongoing',
    };
  },
  watch: {
    property_search: function (newVal, oldVal) {
      if (newVal.trim() != oldVal.trim()) {
        this.page = 1;
        this.getProperties();
      }
    },
  },
  created() {
    // this.getProperties();
  },
  methods: {
    beforeOpen: function () {
      // console.log("open");
      this.property_loader = false;
      this.customerDetails = false;
      this.property_search = "";
      this.page = 1;
      this.property_list = [];
      this.pagination = [];
    },
    closeModal() {
      //   this.showCardetails = null;
      this.page = 1;
      //   this.application = "pending";
      this.property_list = [];
      this.load_more = false;
      //   this.pending_applications = [];
      //   this.showUserContactDetails = false;
      // this.showVehicleForm = false;
      //   this.applicationSwitcher('pending');
      this.$modal.hide("user-active-permit");
      this.$emit("modal_closed");
    },
    getProperties() {
      if (this.property_search === '') {
        this.clearSearch();        
        return;
      } 
      if (this.user_list_source) {
        this.user_list_source.cancel("Cancel previous request");
      }
      this.property_loader = true;
      const CancelToken = this.axios.CancelToken;
      this.user_list_source = CancelToken.source();
      let role = localStorage.getItem("role");
      let property_access_list = "";

      // let property_access=[];
      // console.log(role);
      if (role == "operator") {
        this.property_access = localStorage.getItem("commercial_access_list");
        this.property_access = JSON.parse(this.property_access);
        property_access_list = this.property_access.property_access_list;
      }
      // console.log(localStorage.getItem('admin_access'));
      this.admin_access = localStorage.getItem("admin_access");

      this.axios
        .post(
          window.hostname + "api/auth/permit/search-properties",
          {
            search: this.property_search,
            mode: this.quick_search_mode,
            page: this.page,
            access_property_ids: property_access_list,
            admin_access: this.admin_access,
            commercial: 1,
          },
          {
            cancelToken: this.user_list_source.token,
          }
        )
        .then((res) => {
          // console.log(res.data);
          if (res.status) {
            this.property_list = res.data.data.user_details;
            this.pagination = res.data.data.pagiantion;
            this.load_more =
              res.data.data.pagination.load_more == 1 ? true : false;
            this.page =
              res.data.data.pagination.load_more == 1
                ? res.data.data.pagination.page
                : 1;
          }
          
          this.property_loader = false;
        })
        .catch((err) => {
          // console.log(err);
          if (err.message !== 'Cancel previous request') {
            this.property_loader = false;
          }
        });
    },
    async getPaginateUsers($state) {
      // if(this.user_list_source){
      //   this.user_list_source.cancel("Cancel previous request");
      // }
      // this.property_access =localStorage.getItem('commercial_access_list');
      let role = localStorage.getItem("role");
      let property_access_list = "";
      if (role == "operator") {
        this.property_access = localStorage.getItem("commercial_access_list");
        this.property_access = JSON.parse(this.property_access);
        property_access_list = this.property_access.property_access_list;
      }
      await this.axios
        .post(
          window.hostname + "api/auth/permit/search-properties",
          {
            search: this.property_search,
            mode: this.quick_search_mode,
            admin_access: this.admin_access,
            commercial: 1,
            page: this.page,
            access_property_ids: property_access_list,
          },
          {
            cancelToken: this.user_list_source.token,
          }
        )
        .then((res) => {
          // console.log(res);
          // this.monthly_loader = false ;
          if (res.status) {
            if (Object.keys(res.data.data).length !== 0) {
              let data = res.data.data.user_details;
              // console.log("data",data);
              data.map((val) => {
                this.property_list.push(val);
              });
              // console.log( res.data.data.pagination.load_more);
              this.load_more =
                res.data.data.pagination.load_more == 1 ? true : false;
              this.page =
                res.data.data.pagination.load_more == 1
                  ? res.data.data.pagination.page
                  : 1;
              if (this.load_more) {
                $state.loaded();
              } else {
                $state.complete();
              }
            } else {
              this.property_list = [];
              this.load_more = false;
              // this.search_infiniteId += 1;
              this.page = 1;
              $state.complete();
            }
          }
        })
        .catch((err) => {
          if (this.axios.isCancel(err)) {
            // this.monthly_loader = true ;
            console.log("Request canceled", err.message);
          } else {
            // this.monthly_loader = false ;
            $state.error();
            console.log(err);
          }
        });
    },
    setQuickSearchMode(mode) {
      this.quick_search_mode = mode;
      this.property_search = "";
      this.property_list = [];
      this.load_more = false;
      this.page = 1;
      this.$refs.searchField.focus();
    },
    clearSearch() {
        this.property_search = "";
        this.page = 1;
        this.load_more = false;
        this.property_list = [];
        if (this.$refs.searchField) this.$refs.searchField.focus();
    },
    showCustomerDetails(user) {
      this.userDetails = user;
      // console.log(this.userDetails);
      this.customerDetails = true;
    },
    getCreditcardLogo(card) {
      var image = require("@/assets/images/DebitCardImage/credit-card.png");
      try {
        image = require("@/assets/images/DebitCardImage/" + card + ".png");
      } catch (e) {
        image = require("@/assets/images/DebitCardImage/credit-card.png");
      }
      return image;
    },
    getOneSession(session, session_type, validation_id) {
      this.$modal.show("session-details", {
        data: session,
        session_type: session_type,
        property_id: this.space_id,
        validation_id: validation_id,
      });
    },
    getOneUser(user) {
      this.$modal.show("user-details", { user });
    },
    getUserDetails(space_id, booking_id, session_type) {
      this.axios
        .post(window.hostname + "api/auth/booking", {
          space_id: space_id,
          mode: "show-booking",
          booking_for: "owner",
          booking_type: 1,
          session_type: 1,
          booking_id: booking_id,
          time_zone: this.$moment.tz.guess(new Date()),
        })
        .then((res) => {
          // console.log(res.data.status);
          if (res.data.status) {
            this.getOneSession(
              res.data.data.booking_details,
              res.data.data.booking_details.session_type
            );
          }
          // console.log(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getSessionDetails(space_id, booking_id, session_type) {
      this.axios
        .post(window.hostname + "api/auth/booking", {
          space_id: space_id,
          mode: "show-booking",
          booking_for: "owner",
          booking_type: 1,
          session_type: 1,
          booking_id: booking_id,
          time_zone: this.$moment.tz.guess(new Date()),
        })
        .then((res) => {
          // console.log(res.data.status);
          if (res.data.status) {
            this.getOneSession(
              res.data.data.booking_details,
              res.data.data.booking_details.session_type
            );
          }
          // console.log(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style scoped>
*::-webkit-scrollbar {
  width: 8px;
}

*::-webkit-scrollbar-track {
  background: rgb(63, 61, 61);
  border-radius: 10px;
}

*::-webkit-scrollbar-thumb {
  background-color: grey;
  border-radius: 20px;
}
.scroll-black * {
  scrollbar-width: thin;
  scrollbar-color: rgb(70, 70, 70) auto;
}
</style>
